/**
 * @author       luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { css } from '@emotion/react'

import minus from '../../img/Minus.svg'
import plus from '../../img/Plus.svg'

export const mapContainer = css`
  width: 100%;
  height: 100%;

  // the styles below ensure map appears on page refresh
  > .mapboxgl-map {
    width: 100% !important;
    height: 100% !important;
  }

  .mapboxgl-ctrl-group button {
    height: 32px;
    width: 32px;

    &:first-of-type {
      border-radius: 6px 6px 0 0;
    }
    &:last-of-type {
      border-radius: 0 0 6px 6px;
    }
  }

  .mapboxgl-ctrl-group:not(:empty) {
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  }

  .mapboxgl-ctrl-group button + button {
    border-top: 1px solid #ddd;
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon {
    background-image: url(${plus});
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon {
    background-image: url(${minus});
  }
`

export const maptoolsBottomRight = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`
